<style lang="less" scoped>
.compare-box {
  padding: 15px;
  border-radius: 10px;
  border: 2px dashed #eee;
  margin-top: 20px;
}
.preview-list {
  display: flex;
  flex-direction: row;
  /*> *:nth-child(2){
      margin-left: 25px;
    }*/
  > * {
    flex: 1;
    /deep/.preview-box {
      margin: 20px auto 0 !important;
    }
  }

  .preview-title {
    margin-bottom: 10px;
    text-align: center;
    width: 100%;
  }
}
</style>

<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title">
      <i class="iconfont icon-zaixianduibiweijihuo"></i> 人脸对比
    </div>
    <div class="main-shadow-box">
      <div v-show="!files.length" class="tip">
        <i class="el-icon-sunrise-1"></i> 请选择两张图片
      </div>
      <image-select multiple @select="selectFile"></image-select>
      <!-- <el-switch v-model="ifCheckAlive" style="margin-left: 10px;" active-text="是否活体检测"></el-switch> -->
      <div style="float: right;">
        <label style="margin-right: 10px; font-size: 14px;">检测类型</label>
        <el-radio-group v-model="compareType">
          <el-radio-button label="人脸对比"></el-radio-button>
          <el-radio-button label="6合1人脸对比"></el-radio-button>
          <el-radio-button label="6合1众志人脸对比"></el-radio-button>
          <el-radio-button label="122人脸对比"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="compare-box" v-show="files.length">
        <div class="preview-list">
          <image-preview :file="files[0]">
            <div class="preview-title">图片1</div>
          </image-preview>
          <image-preview :file="files[1]">
            <div class="preview-title">图片2</div>
          </image-preview>
        </div>
        <div style="margin-top: 30px; text-align: center;">
          <el-button @click="reset">重置</el-button>
          <el-button
            type="primary"
            :disabled="files.length < 2"
            @click="handleCompare"
            :loading="buttonLoading"
            :title="files.length < 2?'需选择两张图片':''"
          >对比</el-button>
          <br />
        </div>
      </div>
      <div v-if="message&&!ifCheckAlive" style="text-align: center; margin-top: 20px;">{{message}}</div>
      <div v-if="message&&ifCheckAlive" style="text-align: center; margin-top: 20px;">
        {{message}}，图片1活体检测结果：{{aliveCheck1 | alive}}、图片2活体检测结果：{{aliveCheck2 | alive}}</div>
    </div>
  </div>
</template>
<script>
import ImagePreview from "@/components/image-preview.vue";
import ImageSelect from "@/components/image-select.vue";

export default {
  components: {
    ImageSelect,
    ImagePreview
  },
  data() {
    return {
      files: [],
      message: "",
      ifCheckAlive: false,
      compareType: '人脸对比',
      buttonLoading: false,
      aliveCheck1: '',
      aliveCheck2: ''
    };
  },

  methods: {
    reset() {
      this.files = [];
      this.message = "";
    },
    selectFile(files) {
      if (files.length + this.files.length > 2) {
        this.reset();
      }
      this.files = this.files.concat(files).slice(0, 2);
    },
    handleCompare() {
      this.buttonLoading = true
      if(this.compareType==='人脸对比'){
        this.compare()
      }else if(this.compareType==='6合1人脸对比'){
        this.compare6n1()
      }else if(this.compareType==='6合1众志人脸对比'){
        this.compare6n1zz()
      }else if(this.compareType==='122人脸对比'){
        this.compare122()
      }else{
        this.$message.warning('请选择人脸对比的类型')
        this.buttonLoading = false
      }
    },
    async compare() {
      try {
        if (this.ifCheckAlive) {
          this.aliveCheck1 = '';
          this.aliveCheck2 = '';
          let res = await this.$request(
            this.$api.face1vs1.compareAndCheckAlive({
              image1: this.files[0],
              image2: this.files[1]
            })
          );
          this.message =
            "对比结果：置信度 " +
            Math.round(res.match * 100 * 100) / 100 + '%' ;
          this.aliveCheck1 = res.info1;
          this.aliveCheck2 = res.info2;
        } else {
          let res = await this.$request(
            this.$api.face1vs1.compare({
              image1: this.files[0],
              image2: this.files[1]
            })
          );
          this.message =
            "对比结果：置信度 " + Math.round(res.match * 100 * 100) / 100 + "%";
        }
      } catch ({ response }) {
        this.message = response.data;
      } finally {
        this.buttonLoading = false
      }
    },
    async compare6n1() {
      let res = await this.$request(
        this.$api.face1vs1.compare6n1({
          db_image: await this.getBase64(this.files[0]),
          query_image1: await this.getBase64(this.files[1])
        })
      );
      if (res.code === "-1") {
        this.message = res.message
      } else {
        this.message =
          "6合1对比结果：置信度 " +
          Math.round(res.similarity * 100 * 100) / 100 +
          "%";
      }
      this.buttonLoading = false
    },
    async compare6n1zz() {
      let res = await this.$request(
        this.$api.face1vs1.compare6n1zz({
          db_image: await this.getBase64(this.files[0]),
          query_image1: await this.getBase64(this.files[1])
        })
      );
      if (res.code === "-1") {
        this.message = res.message
      } else {
        this.message =
          "6合1众志对比结果：置信度 " +
          Math.round(res.similarity * 100 * 100) / 100 +
          "%";
      }
      this.buttonLoading = false
    },
    async compare122() {
      let res = await this.$request(
        this.$api.face1vs1.compare122({
          db_image: await this.getBase64(this.files[0]),
          query_image1: await this.getBase64(this.files[1])
        })
      );
      if (res.code === "-1") {
        this.message = res.message
      } else {
        this.message =
          "122对比结果：置信度 " +
          Math.round(res.similarity * 100) / 100 +
          "%";
      }
      this.buttonLoading = false
    },
    getBase64(file) {
      let reader = new FileReader();
      let imgFile;
      reader.readAsDataURL(file);
      return new Promise((resolve, _) => {
        reader.onload = e => {
          let arr = e.target.result.split(",");
          resolve(arr[1]);
        };
      });
    }
  }
};
</script>

